import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionFormEditMain = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsFormsDashboard/InspectionFormEdit/InspectionFormMainEdit/InspectionFormMainEdit"
    )
);

export const InspectionFormsEdit = () => {
  return (
    <Layout>
      <InspectionFormEditMain />
    </Layout>
  );
};
